export const RECEIVE_REPORTS = "RECEIVE_REPORTS";
export const RECEIVE_ADDITIONAL_INFO = "RECEIVE_ADDITIONAL_INFO";
export const PASS_STATES = "PASS_STATES";
export const UPDATE_REPORTS = "UPDATE_REPORTS";
export const SAVE_FILTERING_PARAMS = "SAVE_FILTERING_PARAMS";
export const APPLY_FILTERING = "APPLY_FILTERING";
export const CLEAR_FILTERING = "CLEAR_FILTERING";
export const RECEIVE_REPORTS_FOR_LIST = "RECEIVE_REPORTS_FOR_LIST";
export const RECEIVE_USER = "RECEIVE_USER";

export const AGGREGATED_REPORTS_FILTERS = {
  by_label: [],
  by_state: [],
  by_severity: [],
  hide_closed: true,
  triaged_by_hackenproof: false,
  self_triaged: false,
  with_new_message: false,
};

const FILTERS_LABELS_MAP = {
  hide_closed: "Hidden closed reports",
  triaged_by_hackenproof: "Triaged by HackenProof",
  with_new_message: "Unread messages",
  self_triaged: "Self-Triage",
};

export const CLOSED_STATES = [
  "informative",
  "duplicate",
  "spam",
  "not_applicable",
  "out_of_scope",
  "resolved",
  "disclosed",
  "deleted",
];

export const getChipsData = (data) =>
  Object.keys(AGGREGATED_REPORTS_FILTERS).reduce(
    (acc, filterType) => [
      ...acc,
      ...(Array.isArray(data[filterType])
        ? data[filterType].map((v) => ({ type: filterType, key: v }))
        : data[filterType]
        ? [{ type: filterType, key: FILTERS_LABELS_MAP[filterType] }]
        : []),
    ],
    []
  );

export const NOTIFICATION_TYPES = {
  INFO: "info",
  WARNING: "warning",
  SUCCESS: "success",
  ERROR: "error",
};
